
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'CircleImage',
    components: {},
    props: {
        text: {
            type: String,
            required: true,
        },
        image: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            default: '',
        },
        isDisabled: {
            type: Boolean,
            default: false,
        },
    },
});
